import { usePriceUnitCategories } from '@/components/combobox/combobox-queries';
import { extractDropdownValue } from '@/utils/dropdown';
import { Dropdown, HelpText, Label } from '@lego/connect-components-react';
import { useRef, useState } from 'react';

type PriceUnitCategoryDropdownProps = {
  selectedValue: string;
  onChange: (value: string) => void;
};

const PriceUnitCategoryDropdown = ({
  selectedValue,
  onChange,
}: PriceUnitCategoryDropdownProps) => {
  const { data: categories, isLoading } = usePriceUnitCategories();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const isManualMode = !!selectedValue;

  return (
    <div
      ref={dropdownRef}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
      }}
    >
      <Label forId="price-unit-category-dropdown">
        Planning price lists by category
      </Label>
      <Dropdown
        id="price-unit-category-dropdown"
        placeholder="Select a category"
        fullWidth
        multiple={false}
        value={selectedValue ? [selectedValue] : []}
        loading={isLoading}
        isOpen={isDropdownOpen}
        onOpenChange={setIsDropdownOpen}
        showClearButton
        portalTarget={dropdownRef.current}
        onChange={(_event, value) => {
          onChange(extractDropdownValue(value));
        }}
      >
        {categories?.map((category) => (
          <Dropdown.Option key={category.id} value={String(category.id)}>
            {category.name}
          </Dropdown.Option>
        ))}
      </Dropdown>
      {isManualMode && (
        <HelpText>
          Selecting a category applies all its price lists. Clear the selection
          to manually select price lists.
        </HelpText>
      )}
    </div>
  );
};

export default PriceUnitCategoryDropdown;
